export const THEME = {
  primary: '#8B5CF6',
  primaryLight: '#A78BFA',
  primaryDark: '#7C3AED',
  primaryGlow: '0 0 20px rgba(139, 92, 246, 0.4)',
  primaryGlowStrong: '0 0 30px rgba(139, 92, 246, 0.6)',
  primaryBg: 'rgba(139, 92, 246, 0.08)',
  primaryBorder: 'rgba(139, 92, 246, 0.2)',
  primaryBorderActive: 'rgba(139, 92, 246, 0.4)',

  bg: '#0A0A0B',
  bgCard: 'rgba(22, 22, 28, 0.95)',
  bgCardHover: 'rgba(30, 30, 38, 0.95)',
  bgSurface: 'rgba(255, 255, 255, 0.03)',
  border: 'rgba(255, 255, 255, 0.06)',
  borderHover: 'rgba(255, 255, 255, 0.12)',

  text: '#FFFFFF',
  textSecondary: 'rgba(255, 255, 255, 0.5)',
  textMuted: 'rgba(255, 255, 255, 0.3)',
  textAccent: '#A78BFA',
} as const;

export const SPRING = {
  snappy: { type: 'spring' as const, stiffness: 500, damping: 30 },
  smooth: { type: 'spring' as const, stiffness: 300, damping: 30 },
  gentle: { type: 'spring' as const, stiffness: 200, damping: 25 },
} as const;
